export default __webpack_public_path__ + "static/bba-best-childrens-provider-0016bd0bc26ada10274005edbe059a4a.png";